import { ChevronRight, type LucideIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export type SettingsView =
	| 'general'
	| 'medicare'
	| 'discipline'
	| 'assessment'
	| 'visit'
	| 'style'
	| 'frequency-defaults'
	| 'pharmacies'
	| 'physicians'
	| 'insurance'
	| 'facilities'
	| 'language'
	| 'physician-groups'
	| 'users'
	| 'technical'
	| 'intervention-definitions'
	| 'oasis-definitions';

export interface SettingsSectionItem {
	title: string;
	description: string;
	TitleIcon: LucideIcon;
	settingsView: SettingsView;
}

export interface SettingsSectionProps extends SettingsSectionItem {
	routePrefix?: string;
}

export function SettingsSection({ title, description, TitleIcon, settingsView, routePrefix }: SettingsSectionProps) {
	const navigate = useNavigate();
	return (
		<button
				onClick={() => (routePrefix ? navigate(`${routePrefix}/${settingsView}`) : navigate(`${settingsView}`))}
				type="button"
				className="group w-full rounded-lg border border-gray-200 bg-white p-6 text-left shadow-sm transition-all hover:shadow-md"
			>
				<div className="flex items-start justify-between">
					<div className="flex items-start gap-4">
						<div className="rounded-lg bg-primary-50 p-3 transition-colors group-hover:bg-primary-100">
							<TitleIcon className="size-6 text-primary-600" />
						</div>
						<div>
							<h3 className="mb-1 text-lg font-semibold text-gray-900">{title}</h3>
							<p className="text-sm text-gray-600">{description}</p>
						</div>
					</div>
					<ChevronRight className="size-5 shrink-0 text-gray-400 transition-colors group-hover:text-primary-600" />
				</div>
			</button>
	);
}
